import { useRef, useEffect } from 'react';

import type { ICustomizeTagInputInstance } from '@gp/components/CustomizeTagInput';

export default function useCustomizeTagInputAutoFocus(props?: { deps?: React.DependencyList }) {
  const { deps } = props || {};

  const customizeTagInput = useRef<ICustomizeTagInputInstance>(null);

  useEffect(() => {
    customizeTagInput.current?.focusInputEl();
  }, [deps]);

  return customizeTagInput;
}
